import { type PropsWithChildren } from "react";

type Props = {
  title: string;
};

export const SettingsPage = ({ title, children }: PropsWithChildren<Props>) => (
  <div className="flex flex-col gap-4 w-full max-w-5xl">
    <div className="flex items-start justify-between py-4">
      <h1 className="heading-4">{title}</h1>
    </div>
    {children}
  </div>
);
